import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { gbp, num, toParams } from "@/lib/format";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { OrdersTable } from "@/components/OrdersTable";

export const DrillOrdersSheet = ({ open, onClose, filters, onOpenOrder }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!open) return;
    setData(null);
    api.get("/orders", { params: { ...toParams(filters), limit: 200 } }).then((r) => setData(r.data));
  }, [open, filters]);
  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="w-full overflow-y-auto sm:max-w-5xl" data-testid="drill-orders-sheet">
        <SheetHeader className="mb-4 text-left">
          <div className="label-xs !text-[#FF0000]">Drill-down</div>
          <SheetTitle className="font-display text-2xl">Underlying orders</SheetTitle>
          {data && <div className="text-sm text-slate-500" data-testid="drill-orders-summary">{num(data.total)} orders · <b className="text-slate-900">{gbp(data.total_value)}</b>{data.total > 200 && " · showing latest 200"}</div>}
        </SheetHeader>
        {!data ? <div className="label-xs">Loading…</div> : <OrdersTable items={data.items} onOpen={onOpenOrder} />}
      </SheetContent>
    </Sheet>
  );
};
